import { useEffect, useState, useCallback } from 'react';
import { useAuth, useChangeMessageState } from '@BUP/hooks';
import { BraveBupAPI } from '@BUP/services/Axios';
import { ADMIN, ECE, COMMENT_OPEN } from '@BUP/constants';
import { message } from 'antd';
import { useTranslation } from 'react-i18next';

export function useInboxMessages() {
  const { user } = useAuth();
  const [t] = useTranslation();
  const [handleChangeMessageState] = useChangeMessageState();
  const [listState, setListState] = useState({
    isLoading: false,
    messages: [],
    error: null,
  });

  const role = user?.roles?.type;
  const organizationId = user?.organizations?.id;
  const enrollmentId = user?.enrollmentId;

  const getMessages = useCallback(async () => {
    setListState((prevState) => ({
      ...prevState,
      error: null,
      isLoading: true,
    }));
    try {
      if (role === ECE || role === ADMIN) {
        const response = await BraveBupAPI.get('/comments', {
          params: {
            parent_comment_id: 'null',
            organizationId,
          },
        });
        const messages = response.data;
        const sortedMessages = messages.sort(
          (a, b) => new Date(b?.createdAt) - new Date(a?.createdAt)
        );
        setListState((prevState) => ({
          ...prevState,
          messages: sortedMessages,
        }));
      } else {
        const response = await BraveBupAPI.get('/comments', {
          params: {
            parent_comment_id: 'null',
            organizationId,
            enrollmentId,
          },
        });
        const messages = response.data;
        const sortedMessages = messages.sort(
          (a, b) => new Date(b?.createdAt) - new Date(a?.createdAt)
        );
        setListState((prevState) => ({
          ...prevState,
          messages: sortedMessages,
        }));
      }
    } catch (e) {
      console.log('useInboxMessages error', e);
      setListState((prevState) => ({
        ...prevState,
        error: e,
      }));
    } finally {
      setListState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }
  }, [role, organizationId, enrollmentId, setListState]);

  const setMessageState = async (messageId, newState) => {
    const moveTo =
      newState === COMMENT_OPEN
        ? t('pages.modeBup.messageState.text1')
        : t('pages.modeBup.messageState.text2');
    try {
      await handleChangeMessageState(messageId, newState);
      setListState((prevState) => ({
        ...prevState,
        messages: prevState.messages.filter(
          (message) => message.id !== messageId
        ),
      }));
      message.success(
        `${t('pages.modeBup.messageState.messageSuccess')} ${moveTo}.`,
        8
      );
    } catch (e) {
      console.log('setMessageState error', e);
      message.error(t('pages.modeBup.messageState.errorMessage'), 7);
    }
  };

  useEffect(() => {
    getMessages();
  }, [getMessages]);

  return {
    isLoading: listState.isLoading,
    messages: listState.messages,
    error: listState.error,
    setMessageState,
  };
}
